"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _domAlign = _interopRequireDefault(require("dom-align"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _dom = require("../utils/dom");
var _data = require("../utils/data");
var _getScrollParent = _interopRequireDefault(require("../utils/dom/getScrollParent"));
var _Layer = _interopRequireDefault(require("./Layer"));
var _configProvider = require("../config-provider/configProvider");
var _resizeObserver = _interopRequireDefault(require("../utils/dom/resizeObserver"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/no-find-dom-node */
var DEFAULT_ALIGN = {
  points: ['bc', 'tc']
};
var DEFAULT_ZINDEX = 1030;
function isScrollEl(el) {
  if (!el || el.nodeType !== 1) return false;
  var _getComputedStyle = getComputedStyle(el),
    overflow = _getComputedStyle.overflow,
    position = _getComputedStyle.position;
  if (overflow === 'visible' || position === 'static') return false;
  return true;
}
var PopLayer = /*#__PURE__*/function (_Component) {
  function PopLayer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PopLayer);
    _this = _callSuper(this, PopLayer, [props]);
    (0, _defineProperty2.default)(_this, "elIndex", 0);
    (0, _defineProperty2.default)(_this, "mounted", false);
    (0, _defineProperty2.default)(_this, "removeElResize", {});
    (0, _defineProperty2.default)(_this, "targetElement", null);
    (0, _defineProperty2.default)(_this, "containerElement", null);
    (0, _defineProperty2.default)(_this, "removeResize", null);
    (0, _defineProperty2.default)(_this, "popLayerContainer", void 0);
    (0, _defineProperty2.default)(_this, "removeScrollListener", null);
    (0, _defineProperty2.default)(_this, "width", void 0);
    (0, _defineProperty2.default)(_this, "handleScroll", (0, _throttle.default)(function () {
      _this.forceAlign();
    }, 200));
    (0, _defineProperty2.default)(_this, "setLayerWidth", function () {
      var _this$props = _this.props,
        equalTargetWidth = _this$props.equalTargetWidth,
        getTargetElement = _this$props.getTargetElement;
      if (!equalTargetWidth) return null;
      var _ref = getTargetElement() || {},
        offsetWidth = _ref.offsetWidth;
      if (offsetWidth === _this.width) return null;
      _this.width = offsetWidth;
      _this.state && _this.setState({
        width: offsetWidth
      });
      return offsetWidth;
    });
    (0, _defineProperty2.default)(_this, "forceAlign", function () {
      var _Array$from, _this$popLayerContain;
      if (!_this.mounted) return;
      var _this$props2 = _this.props,
        onAlign = _this$props2.onAlign,
        align = _this$props2.align,
        getTargetElement = _this$props2.getTargetElement;
      // 除被监听宽高节点以外的 element
      var popElement = Array === null || Array === void 0 || (_Array$from = Array.from(((_this$popLayerContain = _this.popLayerContainer) === null || _this$popLayerContain === void 0 ? void 0 : _this$popLayerContain.childNodes) || [])) === null || _Array$from === void 0 ? void 0 : _Array$from.find(
      // @ts-ignore
      function (v) {
        return !(v.tagName === 'OBJECT' && v.className === 'resize-sensor');
      });
      /*
       * display: none时，不触发domAlign
       * @ts-ignore
       */
      if (popElement && getComputedStyle(popElement).display === 'none') {
        return;
      }
      var targetElement = getTargetElement();
      _this.targetElement = targetElement;
      if (targetElement && popElement) {
        _this.handleInitListener(targetElement);
        var result = (0, _domAlign.default)(popElement, targetElement, align);
        if (onAlign) {
          onAlign(result, popElement, targetElement);
        }
      }
    });
    // 设置ResizeObserver对目标元素样式进行监听的回调
    (0, _defineProperty2.default)(_this, "handleResizeObserver", function () {
      _this.forceAlign();
      _this.setLayerWidth();
    });
    (0, _defineProperty2.default)(_this, "handleInitListener", function (targetElement) {
      if (!(0, _data.isEmptyArray)(Object.keys(_this.removeElResize))) return;
      var scrollParent = (0, _getScrollParent.default)(targetElement);
      if (scrollParent !== _this.containerElement) {
        // 监听滚动，重新定位
        _this.removeElResize[_this.elIndex++] = (0, _dom.addElementEventListener)(scrollParent, 'scroll', function () {
          _this.forceAlign();
        });
      }
      // 定位参照节点宽高变化时，重新定位元素，并更新弹窗的宽度
      _this.removeElResize[_this.elIndex++] = (0, _dom.addElementResizeListener)(targetElement, function () {
        _this.forceAlign();
        _this.setLayerWidth();
      });
      var parentNode = _this.popLayerContainer.parentNode;
      // 如果父节点未设置滚动，则不监听，避免影响样式
      if (!isScrollEl(parentNode)) return;
      // 容器节点内容宽高变化时，重新定位元素
      Array.from(parentNode.childNodes).filter(function (v) {
        return v && v !== _this.popLayerContainer && v.nodeType === 1 && !isScrollEl(parentNode);
      }).forEach(function (node) {
        _this.removeElResize[_this.elIndex++] = (0, _dom.addElementResizeListener)(node, function () {
          _this.forceAlign();
        });
      });
      // 容器节点宽高变化时，重新定位元素
      _this.removeElResize[_this.elIndex++] = (0, _dom.addElementResizeListener)(_this.popLayerContainer.parentNode, function () {
        _this.forceAlign();
      });
    });
    _this.state = {
      width: _this.setLayerWidth()
    };
    _this.getContainer = _this.getContainer.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(PopLayer, _Component);
  return (0, _createClass2.default)(PopLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.mounted = true;
      this.removeResize = (0, _dom.addEventListener)('resize', this.forceAlign);
      this.setLayerWidth();
      var onMounted = this.props.onMounted;
      this.forceUpdate(function () {
        return onMounted && onMounted(_this2.popLayerContainer, _this2);
      });
      this.forceUpdate(function () {
        return _this2.forceAlign();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.forceAlign();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.removeResize && this.removeResize();
      this.removeScrollListener && this.removeScrollListener();
      Object.values(this.removeElResize).forEach(function (fn) {
        return fn();
      });
      if (this.popLayerContainer && this.popLayerContainer.parentNode) {
        this.popLayerContainer.parentNode.removeChild(this.popLayerContainer);
      }
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      var _this$props3 = this.props,
        getContainer = _this$props3.getContainer,
        className = _this$props3.className,
        zIndex = _this$props3.zIndex;
      var getPopupContainer = this.context.getPopupContainer;
      var popLayerContainer = document.createElement('div');
      popLayerContainer.className = className !== null && className !== void 0 ? className : '';
      popLayerContainer.style.position = 'absolute';
      popLayerContainer.style.top = '0';
      popLayerContainer.style.left = '0';
      popLayerContainer.style.width = '100%';
      popLayerContainer.style.zIndex = String(zIndex);
      var mountNode = getContainer ? getContainer() : getPopupContainer();
      if (mountNode) {
        mountNode.appendChild(popLayerContainer);
      }
      this.containerElement = mountNode;
      this.popLayerContainer = popLayerContainer;
      return popLayerContainer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        children = _this$props4.children,
        equalTargetWidth = _this$props4.equalTargetWidth;
      var width = this.state.width;
      var validChild = /*#__PURE__*/_react.default.isValidElement(children) ? children : ( /*#__PURE__*/_react.default.createElement("div", null, children));
      return /*#__PURE__*/_react.default.createElement(_Layer.default, {
        getContainer: this.getContainer
      }, /*#__PURE__*/_react.default.createElement(_resizeObserver.default, {
        onResize: this.handleResizeObserver
      }, /*#__PURE__*/_react.default.cloneElement(validChild, {
        style: Object.assign(equalTargetWidth ? {
          width: width
        } : {}, _objectSpread({
          position: 'absolute',
          left: '-9999px'
        }, validChild.props.style))
      })));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(PopLayer, "contextType", _configProvider.ConfigContext);
(0, _defineProperty2.default)(PopLayer, "defaultProps", {
  align: DEFAULT_ALIGN,
  zIndex: DEFAULT_ZINDEX
});
var _default = exports.default = PopLayer;